export default __webpack_public_path__ + "static/media/aboutUsBanner.2503a48d.png";